/*/
 * Alert
 *
 * Text: string
 * Class: alert--i_success | alert--i_error
 * Seconds: time visible in ms
 *
/*/
	window.siteAlert = function (params) {
		params = {
			text: params.text ? params.text : '',
			class: params.class ? params.class : 'alert--i_success',
			seconds: params.seconds ? params.seconds : 6000,
		}

		const alert = document.createElement('div')
		alert.classList.add('alert--i', 'container', 'sp--b-2', params.class)
		alert.innerHTML = `<div class="container--center sp--y-2 sp--x-2 rounded">${params.text}</div>`

		document.querySelector('#app').appendChild(alert);

		setTimeout(function () { alert.classList.add('is--shown') }, 500)
		setTimeout(function () {
			alert.classList.add('is--hide')
			alert.classList.remove('is--shown')
		}, params.seconds)
		setTimeout(function () { alert.remove() }, params.seconds + 500)

		alert.addEventListener('click', function () {
			this.classList.remove('is--shown')
			this.classList.add('is--hide')
			setTimeout(function () { alert.remove() }, 300)
		})
	}
